
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 13"}},[_c('path',{attrs:{"fill":"currentColor","d":"M30.571 7.924h-.001l-4.288 4.354-1.43-1.451 3.278-3.328H0V5.445h28.13l-3.278-3.327 1.43-1.451L32 6.473z"}})])
      }
    
      }
    